import type { CapabilityHubContent } from "@/components/services/capability-hub-types";
import { cn } from "@/lib/utils";

const paragraphClass =
  "text-[var(--on-surface-variant)] leading-relaxed text-[1rem] sm:text-[1.0625rem] max-w-[40rem]";

export function CapabilityHubProse({
  hub,
  className,
}: {
  hub: CapabilityHubContent;
  className?: string;
}) {
  return (
    <div className={cn("space-y-6", className)}>
      {hub.paragraphs.map((p, i) => (
        <p key={i} className={paragraphClass} style={{ fontFamily: "var(--font-body)" }}>
          {p}
        </p>
      ))}
      <dl className="max-w-[40rem] space-y-7 pt-1">
        {hub.pillars.map((pillar) => (
          <div
            key={pillar.label}
            className="border-l-2 border-[color-mix(in_srgb,var(--primary)_18%,var(--outline-variant)_82%)] pl-4 sm:pl-5"
          >
            <dt
              className="font-display text-base sm:text-lg text-[var(--on-surface)] tracking-tight leading-snug"
              style={{ fontFamily: "var(--font-display)" }}
            >
              {pillar.label}
            </dt>
            <dd
              className="mt-2 text-[var(--on-surface-variant)] leading-relaxed text-[0.9375rem] sm:text-[1rem]"
              style={{ fontFamily: "var(--font-body)" }}
            >
              {pillar.body}
            </dd>
          </div>
        ))}
      </dl>
      <p
        className="font-display text-[0.9375rem] sm:text-base leading-relaxed text-[var(--on-surface-variant)]/88 max-w-[38rem] pt-1 italic"
        style={{ fontFamily: "var(--font-display)" }}
      >
        {hub.closing}
      </p>
    </div>
  );
}
